import api from './api';

export const getApprovalFlows = (params) => api.get('/v1/approval-flows', { params });
export const getApprovalFlow = (id) => api.get(`/v1/approval-flows/${id}`);
export const createApprovalFlow = (data) => api.post('/v1/approval-flows', data);
export const updateApprovalFlow = (id, data) => api.put(`/v1/approval-flows/${id}`, data);
export const deleteApprovalFlow = (id) => api.delete(`/v1/approval-flows/${id}`);

export const getApprovalFlowUsers = (id) => api.get(`/v1/approval-flows/${id}/users`);
export const assignUsers = (id, data) => api.post(`/v1/approval-flows/${id}/assign`, data);
export const removeUser = (flowId, userId) => api.delete(`/v1/approval-flows/${flowId}/users/${userId}`);

export const getUserApprovalFlows = (userId) => api.get(`/v1/approval-flows/users/${userId}`);
export const getApprovalFlowDetail = (id) => api.get(`/v1/approval-flows/${id}`);

// Ekip / departman bazlı canlı atama (spec 2026-11-01 §4.5). Yazanlar EM.Write + şirket geneli kapsam ister.
export const removeAllUsers = (flowId) => api.delete(`/v1/approval-flows/${flowId}/users`);
export const getConversionSuggestions = (flowId) => api.get(`/v1/approval-flows/${flowId}/conversion-suggestions`);
export const convertToDepartmentRule = (flowId, departmentId) => api.post(
  `/v1/approval-flows/${flowId}/convert-to-department-rule`, { departmentId },
);
// Kaydetmeden önce "kimin akışı değişir?" — gövde: { flowType, addRule?, updateRuleId?, updateRule?, deleteRuleId?,
// removeRelationIds?, removeAllRelationsOfFlowId?, convertFlowId?, convertDepartmentId? }.
export const previewImpact = (body) => api.post('/v1/approval-flows/impact-preview', body);
